import type React from 'react';
import type { GAEventWithoutCallback } from '@noths/polaris-client-google-analytics';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { isMiddleMouseClick } from '@noths/polaris-client-utils';
import type { Dictionary } from '@noths/polaris-dev-ts-recipes';

export type TrackingEvent<T extends Dictionary = Dictionary> = T & GAEventWithoutCallback;

type TrackingEventOrFn<T extends TrackingEvent> =
  | T
  | ((evt: React.MouseEvent<HTMLAnchorElement>) => T);

export const useTrackableLink = () => {
  const trackLinkClick =
    <T extends TrackingEvent>(eventOrFn: TrackingEventOrFn<T>) =>
    (evt: React.MouseEvent<HTMLAnchorElement>) => {
      const trackingEvent = typeof eventOrFn === 'function' ? eventOrFn(evt) : eventOrFn;

      sendGALinkClickEvent(evt, trackingEvent);
    };

  const trackLinkMouseDown =
    <T extends TrackingEvent>(eventOrFn: TrackingEventOrFn<T>) =>
    (evt: React.MouseEvent<HTMLAnchorElement>) => {
      if (isMiddleMouseClick(evt)) {
        const trackingEvent = typeof eventOrFn === 'function' ? eventOrFn(evt) : eventOrFn;

        sendGAEvent(trackingEvent);
      }
    };

  return { trackLinkClick, trackLinkMouseDown };
};
